import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-white text-center px-4">
    <h1 className="text-7xl font-bold text-vern mb-4">404</h1>
    <h2 className="text-2xl md:text-3xl font-semibold mb-2">Page Not Found</h2>
    <p className="text-gray-600 mb-6 max-w-md">
      Sorry, the page you’re looking for doesn’t exist or has been moved.
    </p>
    <Link
      to="/"
      className="bg-vern text-white px-8 py-3 rounded-full text-lg font-medium hover:bg-red-700 transition-colors"
    >
      Go to Homepage
    </Link>
  </div>
);

export default NotFound;
